module.exports = __webpack_public_path__ + "img/screen3.f153ee41.jpg";